export default "/images/4.svg?04f02676ab6bdba56251c5762e4f99e4";